import React from 'react';

/**
 * Loading state shown while a lazily-loaded route chunk downloads.
 * Deliberately minimal and on-brand so the transition never flashes white.
 */
export function RouteFallback() {
  return <div className="flex min-h-screen w-full items-center justify-center bg-cream" role="status" aria-live="polite" data-id="element-374" data-mp="14os4dc90texi">
      <span className="sr-only" data-id="element-375" data-mp="19lime54dyklk">Loading page</span>
      <span aria-hidden="true" className="h-10 w-10 animate-spin rounded-full border-2 border-sage/30 border-t-sage-700" data-id="element-376" data-mp="upkvp2d8e8gq" />
    </div>;
}